module.exports = __webpack_public_path__ + "static/media/removeUserBlue.f4fd97be.svg";